import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "mappingCode1",
		headerName: "Mapping Code 1",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "mappingCode2",
		headerName: "Mapping Code 2",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value || "--",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 380,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Unique Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "bankBranch",
		headerName: "Payment Institution Branch",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "sequenceNumber",
		headerName: "Sequence Number",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	
	...createdAtmodifiedAtActions
];
